import { render, staticRenderFns } from "./StagingCollectionPage.vue?vue&type=template&id=0ffe45f4&scoped=true&"
import script from "./StagingCollectionPage.vue?vue&type=script&lang=js&"
export * from "./StagingCollectionPage.vue?vue&type=script&lang=js&"
import style0 from "./StagingCollectionPage.vue?vue&type=style&index=0&id=0ffe45f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe45f4",
  null
  
)

export default component.exports